export enum QueryKeysEnum {
  GET_CARD_LIST = 'GET_CARD_LIST',
  GET_GIFT_CARD_LIST = 'GET_GIFT_CARD_LIST',
  GET_LEGACY_PAYMENT_API = 'GET_LEGACY_PAYMENT_API',
}
